import { reqAPI } from "../utils/fetch-request";

export async function getProfile() {
  return reqAPI(`api/merchant/profile`);
}

export async function getDataCompany(merchantId, pageNumber) {
  return reqAPI(`api/merchant/page/${pageNumber}`);
}

export async function saveDataCompany(formData, stepNumber) {
  let stepLink;
  if (stepNumber === 1) {
    stepLink = "step-1";
  } else if (stepNumber === 2) {
    stepLink = "step-2";
  } else {
    stepLink = "step-3";
  }

  return reqAPI(`api/merchant/${stepLink}`, formData, "POST", true);
}

export async function uploadDocument(formData) {
  return reqAPI(`api/merchant/upload-document`, formData, "POST", true);
}

export async function nextPopup(formData) {
  return reqAPI(`api/merchant/next-popup`, formData, "POST", true);
}

export async function checkBankAccount(bankName, accountNumber) {
  const formData = new FormData();
  formData.append("bank", bankName);
  formData.append("account_number", accountNumber);

  return reqAPI("api/merchant/check-account-prod", formData, "POST", true);
}

export async function uploadAvatar(formData) {
  return reqAPI(`api/merchant/upload-avatar`, formData, "POST", true);
}

export async function getSummary(params) {
  return reqAPI(`api/merchant/batches/summary`, params);
}

export async function getBank() {
  return reqAPI("api/merchant/bank", null, "GET");
}

export async function getApiCredentials() {
  return reqAPI("api/merchant/api-credentials");
}
